import { createFileRoute } from '@tanstack/react-router';
import { GradeSubmissionScreen } from '@/quiz-submission/GradeSubmissionScreen';

/**
 * The group mount of the grade screen. The form lives in `@/quiz-submission/`
 * and is shared with the member mount; see `GradeSubmissionScreen`.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId',
)({
  component: GroupQuizSubmissionGradeScreen,
});

function GroupQuizSubmissionGradeScreen() {
  const { submissionId } = Route.useParams();
  return (
    <GradeSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
